import { RoutePaths } from 'types/types';
import { HomeMenuItem } from './Home';
import { getRoutePath } from 'utils';
import * as Muicon from '@mui/icons-material';
import { Permission } from 'state/permissionState';

const patientsRoute = {
  path: RoutePaths.patients,
  name: 'home.menu.patients',
  icon: 'SupervisedUserCircle' as keyof typeof Muicon,
  id: 'patients',
};
const usersRoute = {
  path: RoutePaths.users,
  name: 'home.menu.users',
  icon: 'People' as keyof typeof Muicon,
  id: 'users',
};
const exportRoute = {
  path: RoutePaths.export,
  name: 'home.menu.export',
  icon: 'FileDownload' as keyof typeof Muicon,
  id: 'export',
};
const profileRoute = {
  path: RoutePaths.profile,
  name: 'home.menu.profile',
  icon: 'AccountBox' as keyof typeof Muicon,
  id: 'profile',
};
const rootRoute = {
  path: RoutePaths.root,
  name: 'home.menu.logout',
  icon: 'Logout' as keyof typeof Muicon,
  id: 'logout',
};

const projectFormsRoute = {
  path: RoutePaths.forms,
  name: 'general.forms',
  icon: 'TableView' as keyof typeof Muicon,
  id: 'forms',
};

const projectSelector = {
  path: RoutePaths.projectSelector,
  name: 'home.menu.projects',
  icon: 'FolderCopy' as keyof typeof Muicon,
  id: 'projectSelector',
};

const projectDashboard = {
  path: RoutePaths.projectDashboard,
  name: 'home.menu.project',
  icon: 'FolderCopy' as keyof typeof Muicon,
  id: 'projectDashboard',
};

const importRoute = {
  path: RoutePaths.import,
  name: 'home.menu.import',
  icon: 'FileUpload' as keyof typeof Muicon,
  id: 'importRoute',
};

const reportTemplates = {
  path: RoutePaths.reportTemplates,
  name: 'home.menu.reports',
  icon: 'Assignment' as keyof typeof Muicon,
  id: 'reportTemplates',
};

export function getMenuItems({
  permissions,
  projectId,
}: {
  permissions: Permission[];
  projectId?: string;
}): HomeMenuItem[] {
  const COMMON_ROUTES = [
    projectDashboard,
    projectSelector,
    projectFormsRoute,
    reportTemplates,
    patientsRoute,
    usersRoute,
    exportRoute,
    importRoute,
    profileRoute,
    rootRoute,
  ];

  const ROUTES_WHICH_REQUIRE_SELECTED_PROJECT = COMMON_ROUTES.filter(route => {
    switch (route.id) {
      case 'patients':
        return projectId;
      case 'users':
        return projectId;
      case 'importRoute':
        return projectId;
      case 'export':
        return projectId;
      case 'profile':
        return true;
      case 'forms':
        return projectId;
      case 'projectDashboard':
        return projectId;
      case 'reportTemplates':
        return projectId;
      case 'projectSelector':
        return !projectId;
      default:
        return true;
    }
  });

  if (permissions.includes(Permission.SUPERADMIN)) {
    return ROUTES_WHICH_REQUIRE_SELECTED_PROJECT;
  }

  return ROUTES_WHICH_REQUIRE_SELECTED_PROJECT.filter(route => {
    switch (route.id) {
      case 'patients':
        return permissions.includes(Permission.READ_PATIENT);
      case 'users':
        return permissions.includes(Permission.READ_ALL_USER);
      case 'importRoute':
        // TODO: once released to demo server revert this Permission.WRITE_PROJECT
        return permissions.includes(Permission.SUPERADMIN);
      case 'export':
        return projectId;
      case 'reportTemplates':
        // TODO: once released to demo server revert this Permission.WRITE_PROJECT
        return permissions.includes(Permission.SUPERADMIN);
      case 'projectDashboard':
        return projectId;
      case 'projectSelector':
        return !projectId;
      case 'profile':
        return true;
      case 'forms':
        return permissions.includes(Permission.READ_FORM_TEMPLATE);
      default:
        return true;
    }
  });
}

export const getIsMenuItemSelected = (
  menuItem: HomeMenuItem,
  pathname: string,
  ids: {
    id?: string;
    projectId?: string;
  },
) => {
  return getRoutePath(menuItem.path, ids) === pathname;
};
